import React, { createContext, useContext, useEffect, useState } from 'react';
import siteInfoFallback from '../data/siteInfoFallback';

const SiteInfoContext = createContext(null);

function getApiBase() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:4000';
  }
  return '';
}

export function SiteInfoProvider({ children }) {
  const [siteInfo, setSiteInfo] = useState(siteInfoFallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const apiBase = getApiBase();
    const url = `${apiBase}/api/v1/site`;

    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load site info (${res.status})`);
        }
        const contentType = res.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
          throw new Error('Site info response was not JSON');
        }
        return res.json();
      })
      .then((json) => {
        if (json?.data) {
          setSiteInfo(json.data);
        }
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteInfoContext.Provider value={{ siteInfo, loading, error }}>
      {children}
    </SiteInfoContext.Provider>
  );
}

export function useSiteInfo() {
  const context = useContext(SiteInfoContext);
  if (!context) {
    throw new Error('useSiteInfo must be used within SiteInfoProvider');
  }
  return context;
}
